'use strict';

var TRIM_CHARS = require('../../common/var/TRIM_CHARS');

module.exports = RegExp('(?=[' + TRIM_CHARS + '])');


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/string/var/TRUNC_REG.js
// module id = 661
// module chunks = 1